<div
    class="modal fade show"
    [ngClass]="{'expanded': isExpanded}"
    id="ms-dynamic-modal"
    tabindex="-1"
    aria-labelledby="ms-dynamic-modalLabel"
    aria-hidden="true"
    [ngStyle]="{'display': 'block'}"
>
    <div class="modal-dialog modal-lg">
        @if (showLoader) {
<app-loader></app-loader>
}
        <div class="modal-content">
            <div class="modal-body">
                @if (showIframe) {
<iframe
                   
                    [src]="iframeUrl"
                    width="100%"
                    height="100%"
                    style="visibility: visible; border: 1px solid transparent;"
                ></iframe>
}

                @if (chasePaymentSuccessful) {
<app-chase-response-success
                   
                    [transactionID]="transactionID"
                    [transactionDate]="transactionDate"
                    [transactionAmount]="transactionAmount"
                    (close)="ccPaymentComplete($event)"
                ></app-chase-response-success>
}

                @if (chasePaymentFailed) {
<app-chase-response-failed
                   
                    [transactionErrorMessage]="transactionErrorMessage"
                    [transactionErrorCode]="transactionErrorCode"
                    [transactionErrorSuggestion]="transactionErrorSuggestion"
                    (retryPayment)="retryPayment()"
                    (close)="failedAndClose()"
                ></app-chase-response-failed>
}

                @if (chasePaymentFailedForPurchaseOrder) {
<app-po-response-failed
                   
                    [transactionErrorMessage]="transactionErrorMessage"
                    [transactionErrorCode]="transactionErrorCode"
                    [transactionErrorSuggestion]="transactionErrorSuggestion"
                    (retryPayment)="retryPayment()"
                    (close)="failedAndCloseForPurchaseOrder()"
                ></app-po-response-failed>
}

            </div>
        </div>
    </div>
</div>
